import { Pipe, PipeTransform } from '@angular/core';
import { NewsPostIconEnum } from '@sb/library/data-models';
import { PostManager } from '../post.manager';

@Pipe({name: 'postIcon'})
export class PostIconPipe implements PipeTransform {

	constructor(private _PostManager: PostManager) {
	}

    transform(icon: NewsPostIconEnum) {
        const svgIcon = this._PostManager.GetIconName(icon);
        return {Icon: svgIcon};
    }
}
